<div class="mt-20">
    <ng-container *ngIf="displayEditUI()">
        <app-device-transmit-information
            [dateLabel]="dateLabel"
            [cliniciansList]="cliniciansList"
            [activatorClinicFlg]="activatorClinicFlg"
            [orderTransmitterMsg]="orderTransmitterMsg"
            (transmitterSelect)="transmitterSelect($event)"
            [dataMiningFlg]="dataMiningFlg"
            [clinicDetailsInfo]="clinicDetailsInfo"
            [implantIds]="implantIds"
            (togglePhysicianOpt)="togglePhysicianOpt($event)"
            [showPhysicianOpt]="showPhysicianOpt"
            [isUnityCategory]="isUnityCategory"
            [isNGQCategory]="isNGQCategory"
            [isICMCategory]="isICMCategory"
            [isLPCategory]="isLPCategory"
            [dropDownsList]="dropDownInfo"
            [patientDeviceForm]="patientDeviceForm"
            [functionMode]="functionMode"
            [displayMode]="displayMode"
            [patRes]="patRes"
            [userProfile]="userProfile"
            [isBack]="isBack"
        ></app-device-transmit-information>
        <app-patient-details
            [dateLabel]="dateLabel"
            (nameValueChange)="nameValueChange($event)"
            [togglePatientIdValidation]="togglePatientIdValidation"
            [toggleValidation]="togglePatientValidation"
            (patientNumberChange)="patientNumberChange($event)"
            [dropDownsList]="dropDownInfo"
            [patientDeviceForm]="patientDeviceForm"
            [functionMode]="functionMode"
            [displayMode]="displayMode"
            [patRes]="patRes"
            [userProfile]="userProfile"
            [hasDefaultPatientData]="defaultPatientDetails !== undefined">
        </app-patient-details>
        <app-address-contact-information
            [countryCd]="countryCd"
            [isNGQCategory]="isNGQCategory"
            [isICMCategory]="isICMCategory"
            [isLPCategory]="isLPCategory"
            (handleEmergencyCont)="handleEmergencyCont($event)"
            (handleEmailPhone)="handleEmailPhone($event)"
            [toggleEmergencyCont]="toggleEmergencyCont"
            [phoneValidations]="phoneValidations"
            [emailValidations]="emailValidations"
            [showAddrValidations]="showAddrValidations"
            [dropDownsList]="dropDownInfo"
            [patientDeviceForm]="patientDeviceForm"
            [showPhysicianOpt]="showPhysicianOpt"
            [addressDetails]="addressDetails"
            [functionMode]="functionMode"
            [displayMode]="displayMode"
            [patRes]="patRes"
        ></app-address-contact-information>
        <div *ngIf="!activatorClinicFlg">
            <app-direct-call-messaging 
                *ngIf="patResSet" 
                [countryCd]="countryCd" 
                [isICMCategory]="isICMCategory" 
                (markImplantPhyIdSel)="markImplantPhyIdSel($event)" 
                (callMethodChange)="callMethodChange($event)" 
                [dropDownsList]="dropDownInfo" 
                [showPhysicianOpt]="showPhysicianOpt" 
                [showMarkImplantingButton]="showMarkImplantingButton"
                [messageForm]="messageForm" 
                [avaliableIds]="avaliableIds"
                [assignedIds]="assignedIds"
                [medicalOnCallSel]="medicalOnCallSel"
                (avaliableIdList)="avaliableIdListFun($event)"
                (assignedIdList)="assignedIdListFun($event)"
                [functionMode]="functionMode"
                [displayMode]="displayMode"
                [patRes]="patRes"
                (handleEmailPhone)="handleEmailPhone($event)"
                (msgReminderFlgChange)="onMsgReminderFlgChange($event)"
                (msgOverdueFlgChange)="onMsgOverdueFlgChange($event)"
            ></app-direct-call-messaging>
        </div>
    </ng-container>
</div>
